export function contactUsPressed(): void {
  window.open("mailto:info@cap-rx.com");
}
